export function formatPoints(points: number): string {
  return `${points} ${Math.abs(points) === 1 ? 'pt' : 'pts'}`;
}
